import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { GetSalesImportQueryResponse, GetSalesImportsQueryResponse, CreateSalesImportCommand } from '../../interfaces/interfaces';
import { SalesImportService } from 'src/app/services/sales-import.service';
import { MaintainWatchComponent } from '../maintain-watch/maintain-watch.component';
import { map, Observable, take } from 'rxjs';
import { AddEvent, DataStateChangeEvent, GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { State, process, CompositeFilterDescriptor, filterBy } from "@progress/kendo-data-query";
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'sdc-list-watch',
  templateUrl: './list-watch.component.html',
  styleUrls: ['./list-watch.component.scss']
})
export class ListWatchComponent implements OnInit {

  watchForm: UntypedFormGroup;
  userName: string;
  role: string;
  isLoading = false;
  canEdit = false;
  chosenWatch: GetSalesImportsQueryResponse;
  watches = [];
  watchTableDataSource = new MatTableDataSource<GetSalesImportQueryResponse>();
  @ViewChild('watchTablePaginator') watchTablePaginator: MatPaginator;
  watchDisplayColumns: string[] = [
    'name', 'store', 'description', 'dateModified', 'imported', 'importDate', 'actions'];
  watchDisplayHeaders: Array<any> = [
    { key: 'name', header: 'File' },
    { key: 'store', header: 'Store' },
    { key: 'description', header: 'Description' },
    { key: 'dateModified', header: 'Upload Date' },
    { key: 'imported', header: 'Imported' },
    { key: 'importDate', header: 'Import Date' },
  ];

  public gridData: Observable<any>;
  public gridState: State = {
    sort: [],
    skip: 0,
    take: 10,
  };
  public filter: CompositeFilterDescriptor = {
    logic: "and",
    filters: [],
  };
  public newDataItem: CreateSalesImportCommand;
  public editDataItem: GetSalesImportQueryResponse;
  public isNew: boolean;
  public watch: GetSalesImportQueryResponse;

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private watchService: SalesImportService,
    private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.canEdit = true;
    this.userName = localStorage.getItem('currentUserName');
    //alert(localStorage.getItem('currentUserName'));
    //this.role = localStorage.getitem('currentRole');
    //alert(localStorage.getItem('currentRole'));
    this.intialiseData();
  }

  public dataStateChange(state: DataStateChangeEvent): void {
    this.gridState = state;
    //this.gridData = this.watchService.apiWatchGet().pipe(
    //  map((data) => process(data.watches, this.gridState))
    //);
  }

  public addHandler(): void {
    this.editDataItem.id = 0; //new this.editDataItem();
    this.isNew = true;
  }

  public editHandler(args: AddEvent): void {
    this.editDataItem = args.dataItem;
    this.isNew = false;
  }

  public cancelHandler(): void {
    this.editDataItem = undefined;
  }

  public saveHandler(product: GetSalesImportQueryResponse): void {
    //this.watchService.save(product, this.isNew);

    this.editDataItem = undefined;
  }

  //public removeHandler(args: RemoveEvent): void {
    //this.editService.remove(args.dataItem);
  //}

  intialiseData(): void {

    this.gridData = this.watchService.getAllSalesImports().pipe(
      map((data) => process(data.salesImports, this.gridState))
    );
    
    this.watchService.getAllSalesImports().pipe(take(1)).subscribe({
      next: (response: GetSalesImportsQueryResponse) => {
        this.chosenWatch = response;
        this.watches = response.salesImports.map((data) => ({
          id: data.id,
          name: data.name,
          store: data.store,
          description: data.description,
          dateModified: data.dateModified,
          imported: data.imported,
          importDate: data.importDate,
          importFileName: data.importFileName,
        }));
        this.watchTableDataSource.data = this.watches;
        this.watchTableDataSource.paginator = this.watchTablePaginator;
        this.isLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        //alert(error);
        this.isLoading = false;
      }
    });
  }

  createWatch(): void {
    //let date = null;

    const dialogRef = this.dialog.open(MaintainWatchComponent, {
      width: '1300px',
      data: {
        id: 0,
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
    /*var id = 0;
    this.router.navigate(['../watchcreate/' + id]);*/
  }

  updateWatch(args: AddEvent): void {
    var sid = args.dataItem.id;
    this.watch = this.chosenWatch.salesImports.find(x => x.id === sid);
    const dialogRef = this.dialog.open(MaintainWatchComponent, {
      width: '1300px',
      data: this.watch,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      this.intialiseData();
    });
  }

}
